'use strict';

import Handlebars from 'injectify/runtime';

const seleniumAttributes = {

    //login page
    'loginpage.localeselect': 'login-language-select',
    'loginpage.username': 'login-email-input',
    'loginpage.password': 'login-password-input',
    'loginpage.btnlogin': 'login-submit-button',
    'loginpage.lnkpasswordreset': 'forgot-password-link',
    'loginpage.lnkregistration': 'registration-link',
    'loginpage.lnktc': 'footer-tc-link',
    'loginpage.lnkprivacy': 'footer-privacy-link',
    'loginpage.lnksupport': 'footer-support-link',
    'loginpage.lnkfaq': 'footer-faq-link',
    'loginpage.lnkimprint': 'footer-imprint-link',
    'loginpage.btncookieclose': 'cookie-banner-close-button',
    'loginpage.usernameresetpassword': 'reset-password-email-input',
    'loginpage.btncancel': 'reset-password-cancel-button',
    'loginpage.btnreset': 'reset-password-submit-button',

    //registration page
    'registerpage.firstname': 'register-firstname-input',
    'registerpage.lastname': 'register-lastname-input',
    'registerpage.emailaddress': 'register-email-input',
    'registerpage.password': 'register-password-input',
    'registerpage.country': 'register-country-select',
    'registerpage.chkterms': 'register-terms-check',
    'registerpage.btnsubmit': 'register-submit-button',

    //farm page
    'farmpage.searchfarmname': 'search-farm-input',
    'farmpage.btnaddfarm': 'add-new-farm-button',

    //farm settings page
    'farmsettingspage.farmname': 'farm-name-input',
    'farmsettingspage.btnsave': 'save-farm-button',
    'farmsettingspage.btndelete': 'delete-farm-button',
    'farmsettingspage.btnvoucher': 'voucher-button',
    'farmsettingspage.btnshop': 'shop-button',

    //field page
    'fieldpage.txtsearch': 'search-location-input',
    'fieldpage.area': 'field-area',
    'fieldpage.btnassigncrop': 'assign-crop-button',
    'fieldpage.btnedit': 'edit-field-button',
    'fieldpage.btneditplannedcs': 'edit-planned-cs-button',

    //navigation bar
    'generic.btntogglesettings': 'settings-toggle-button',
    'generic.btntogglenotifications': 'notifications-toggle-button',
    'generic.btntogglehelp': 'notifications-toggle-button',
    'generic.btnfarmsettings': 'farm-settings-button',
    'generic.btnfarmlicenses': 'farm-licenses-button',
    'generic.btnswitchfarm': 'switch-farm-button',
    'generic.btnusersettings': 'user-settings-button',
    'generic.btnlogout': 'logout-button',

    //confirmation modal
    'generic.modalinput': 'modal-input',
    'generic.modalbtnprimary': 'modal-primary-button',
    'generic.modalbtnsecondary': 'modal-secondary-button',

    //tablayout ,draw field, upload field layout generic buttons
    'generic.btnexit': 'exit-button',
    'generic.btndelete': 'delete-button',
    'generic.btnback': 'back-button',
    'generic.btnsave': 'save-button',
    'generic.btnnext': 'next-button',
    'generic.btnclear': 'clear-button',

    //create field options
    'generic.btnddetectshapes': 'detect-shapes-button',
    'generic.btndrawshapes': 'draw-shapes-button',
    'generic.btnuploadshapes': 'upload-shapes-button',

    //user settings page
    'usersettingspage.firstname': 'first-name-input',
    'usersettingspage.lastname': 'last-name-input',
    'usersettingspage.email': 'email-input',
    'usersettingspage.taxid': 'tax-id-input',
    'usersettingspage.mobile': 'mobile-input',
    'usersettingspage.phone': 'phone-input',
    'usersettingspage.address': 'address-input',
    'usersettingspage.province': 'province-select',
    'usersettingspage.zip': 'zip-input',
    'usersettingspage.city': 'city-input'
};

Handlebars.registerHelper('selenium', function (key) {

    return seleniumAttributes[key];
});


// WEBPACK FOOTER //
// ./shared/helper/selenium.js